import React, { useEffect, useState, createContext, useContext, ReactNode } from 'react';
import { supabase } from '../supabase';

// 📌 Tipe user
interface User {
  id: string;
  email: string;
}

// 📌 Context type
interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<any>;
  register: (email: string, password: string) => Promise<any>;
  logout: () => Promise<void>;
}

// 📌 Create context
const AuthContext = createContext<AuthContextType | undefined>(undefined);

// 📌 Provider
export function AuthProvider({
  children
}: {
  children: ReactNode;
}) {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // 🔥 ambil session awal
    const getSession = async () => {
      const {
        data
      } = await supabase.auth.getSession();
      if (data.session?.user) {
        setUser({
          id: data.session.user.id,
          email: data.session.user.email!
        });
      }
      setIsLoading(false);
    };
    getSession();

    // 🔥 realtime listener login/logout
    const {
      data: {
        subscription
      }
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) {
        setUser({
          id: session.user.id,
          email: session.user.email!
        });
      } else {
        setUser(null);
      }
    });
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  // 🔐 LOGIN
  const login = async (email: string, password: string) => {
    return await supabase.auth.signInWithPassword({
      email,
      password
    });
  };

  // 📝 REGISTER
  const register = async (email: string, password: string) => {
    return await supabase.auth.signUp({
      email,
      password
    });
  };

  // 🚪 LOGOUT
  const logout = async () => {
    await supabase.auth.signOut();
  };
  return <AuthContext.Provider value={{
    user,
    isAuthenticated: !!user,
    isLoading,
    login,
    register,
    logout
  }} data-id="element-138">
      {children}
    </AuthContext.Provider>;
}

// 📌 Hook
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}